/**
 * Fonts
 */

export const PRIMARY_FONT = 'sofia-pro, sans-serif'
export const SECONDARY_FONT = 'ff-tisa-web-pro, serif'
export const EMPHASIS_FONT = 'sofia-pro-condensed, sans-serif'
